import React from 'react'
import { Alert, AlertTitle, Box, Typography } from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'

interface SavPlanMessagesProps {
  /** Things to look at before importing (renumbered codes, blend problems). */
  warnings: string[] | null | undefined
  /**
   * Plain facts about ordinary data that need no action (a number with no
   * categories, a date that comes in as a number). Absent on plans stored
   * before notes existed.
   */
  notes: string[] | null | undefined
}

/**
 * The inspect plan's messages on the import Review step: real warnings in
 * the orange box, notes underneath as quiet secondary text.
 */
const SavPlanMessages: React.FC<SavPlanMessagesProps> = ({ warnings, notes }) => {
  const w = warnings ?? []
  const n = notes ?? []
  if (w.length === 0 && n.length === 0) return null
  return (
    <>
      {w.length > 0 && (
        <Alert severity="warning" data-testid="sav-import-warnings">
          <AlertTitle>Warnings</AlertTitle>
          {w.map((msg) => (
            <div key={msg}>{msg}</div>
          ))}
        </Alert>
      )}
      {n.length > 0 && (
        <Box data-testid="sav-import-notes" sx={{ display: 'flex', gap: 1, alignItems: 'flex-start', px: 0.5 }}>
          <InfoOutlinedIcon fontSize="small" sx={{ color: 'text.secondary', mt: '2px' }} aria-hidden />
          <Box>
            {n.map((msg) => (
              <Typography key={msg} variant="body2" color="text.secondary">
                {msg}
              </Typography>
            ))}
          </Box>
        </Box>
      )}
    </>
  )
}

export default SavPlanMessages
